export async function ViaCep(cep) {
    const res = await fetch('https://viacep.com.br/ws/' + cep + '/json/')
    const json = await res.json();
    return json;
}